import {
	baseWorkspaceDeviceDefaultsRequestSchema,
	workspaceDefaultsFieldsSchema,
} from "@somewear/workspace";
import { z } from "zod";

export interface OrganizationPickerOption {
	name: string;
	id: string;
}

export const organizationWorkspaceDefaultsSchema = workspaceDefaultsFieldsSchema.extend({
	organizationId: z.string(),
});

export const organizationWorkspaceDefaultsRequestSchema =
	baseWorkspaceDeviceDefaultsRequestSchema.extend({
		// Request settings
		organizationId: z.string(),
	});

export type OrganizationWorkspaceDefaultsSchema = z.infer<
	typeof organizationWorkspaceDefaultsSchema
>;
export type OrganizationWorkspaceDefaultsRequestSchema = z.infer<
	typeof organizationWorkspaceDefaultsRequestSchema
>;
